module.exports = __webpack_public_path__ + "static/img/quizzort_handle.caba1805.png";